import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/_app/certificates')({
  component: CertificatesPage,
})

function CertificatesPage(): JSX.Element {
  return <div>Certificados — placeholder</div>
}
